
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --sic-anchor-nav--default--link-color:var(--color-neutral-light);
  --sic-anchor-nav--default--link-color--hover:var(--color-neutral-white);
  --sic-anchor-nav--default--link-color--active:var(--sic-heading-color);
  --sic-anchor-nav--default--link-border-color:var(--color-primary-default);
  --sic-anchor-nav--default--link-font-size:var(--headline-01-font-size-mid);
  --sic-anchor-nav--default--link-line-height:var(--headline-01-line-height);
  --sic-anchor-nav--default--link-padding:var(--spacing-03) var(--spacing-06);
  --sic-anchor-nav--default--link-border-width:var(--spacing-01);
  --sic-anchor-nav--default--link-background--hover:var(--color-primary-default);
  --sic-anchor-nav--default--link-background--active:var(
  --color-primary-lightest
);

  --layout-gap:var(--sic-anchor-nav--layout-gap, var(--grid-gap));
}
.wrapper{
  display:grid;
  gap:var(--layout-gap);
  grid-template-columns:repeat(12, [col-start] 1fr);
}
aside{
  grid-column:col-start 10 / span 3;
}
.anchor-nav{
  position:sticky;
  top:0px;
  top:var(--sic-anchor-nav--top, 0px);
  background-color:var(--color-neutral-white);
}
ul{
  list-style:none;
  padding-left:0;
  margin:0;
}
.content{
  grid-column:col-start / span 8;
  padding-block-start:var(--spacing-08);
}
::slotted([slot='aside-title']){
  padding-block:var(--spacing-08);
}
::slotted([slot='aside-cta']){
  padding-block-start:var(--spacing-12);
}
.is-mobile.wrapper{
    display:block;
  }
.is-mobile .content{
    padding-block-start:0;
  }
.is-mobile ::slotted([slot='aside-cta']){
    padding-block-start:var(--spacing-02);
    padding-block-end:var(--spacing-04);
  }
.is-mobile aside{
    display:none;
  }
`;